// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

// /** 获取当前的用户 GET /api/currentUser */
// export async function currentUser(options?: { [key: string]: any }) {
//   return request<{
//     data: API.CurrentUser;
//   }>("/api/currentUser", {
//     method: "GET",
//     ...(options || {}),
//   });
// }

/** 현재 사용자 가져오기 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>("/api/admin/currentUser", {
    method: "GET",
    ...(options || {}),
  });
}

// 로그아웃 기본
// /** 退出登录接口 POST /api/login/outLogin */
// export async function outLogin(options?: { [key: string]: any }) {
//   return request<Record<string, any>>("/api/login/outLogin", {
//     method: "POST",
//     ...(options || {}),
//   });
// }

/** 로그아웃 인터페이스 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>("/api/admin/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(
  body: API.LoginParams,
  options?: { [key: string]: any }
) {
  return request<API.LoginResult>("/api/admin/login/account", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>("/api/notices", {
    method: "GET",
    ...(options || {}),
  });
}

// /** 获取规则列表 GET /api/rule */
// export async function rule(
//   params: {
//     // query
//     /** 当前的页码 */
//     current?: number;
//     /** 页面的容量 */
//     pageSize?: number;
//   },
//   options?: { [key: string]: any }
// ) {
//   return request<API.RuleList>("/api/rule", {
//     method: "GET",
//     params: {
//       ...params,
//     },
//     ...(options || {}),
//   });
// }

// /** 모든 유저정보 가져오기 GET /api/admin/users */
export async function getAllUsers(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.UserList>("/api/admin/users", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
// /** 모든 신고정보 가져오기 GET /api/admin/reports */
export async function getAllReports(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.ReportList>("/api/admin/reports", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "update",
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
// export async function addRule(options?: { [key: string]: any }) {
//   return request<API.RuleListItem>("/api/rule", {
//     method: "POST",
//     data: {
//       method: "post",
//       ...(options || {}),
//     },
//   });
// }

// /** 모든 유저정보 가져오기 GET /api/admin/users */
// export async function getAllUsers(options?: { [key: string]: any }) {
//   return request<API.AdminUserListItem>("/api/admin/users", {
//     method: "GET",
//     params: options,
//   });
// }
/**
 * 모든 유저 정보 가져오기 GET /api/admin/users
 * ProTable과 연동되도록 수정한 최종 버전
 */
// export async function getAllUsers(
//   // ProTable이 전달하는 파라미터(current, pageSize 등)
//   params: {
//     current?: number;
//     pageSize?: number;
//   },
//   options?: { [key: string]: any }
// ) {
//   // 백엔드 API를 호출합니다.
//   const response = await request<{
//     success: boolean;
//     data: API.AdminUserListItem[]; // 유저 목록 배열
//     pagination: {
//       total: number; // 전체 아이템 개수
//     };
//   }>("/api/admin/users", {
//     // 실제 API 경로
//     method: "GET",
//     params: {
//       ...params,
//       ...options,
//     },
//   });

//   // ProTable이 요구하는 형식({ data, total, success })으로 변환하여 반환합니다.
//   return {
//     data: response.data,
//     success: response.success,
//     total: response.pagination.total,
//   };
// }

// /** 删除规则 DELETE /api/rule */
// export async function removeRule(options?: { [key: string]: any }) {
//   return request<Record<string, any>>("/api/rule", {
//     method: "POST",
//     data: {
//       method: "delete",
//       ...(options || {}),
//     },
//   });
// }
